import React, { Component } from "react";
import { connect } from "react-redux";

import AdListing from "./adListing";
import { reset } from "redux-form";
import { getAdsList, addNewAd, updateAd, deleteAd } from "../../store/actions";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";
import { flatMap } from "lodash";

class AdManagement extends Component {
	componentDidMount() {
		const { history, isAdmin, getAdsList } = this.props;
		isAdmin === false && history.push("/");

		getAdsList();
	}

	submitAd = (formType, fileType, values, adId) => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				this.props.resetForm("AddOrUpdateAd");
				NotificationManager.success(formType === "Add" ? "Advertisment submitted" : "Advertisment updated", "", 5000);

				this.props.getAdsList();
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};

		const errorHandler = (event) => {
			event &&
				event.error_code === "VALIDATION_ERROR" &&
				NotificationManager.error(`Invalid Fields..., ${event.errors && flatMap(event.errors).toString()}`, "", 5000);
		};

		if (formType === "Add") {
			this.props.addNewAd(values, fileType, successHandler, errorHandler);
		} else if (formType === "Update") {
			this.props.updateAd(values, adId, successHandler, errorHandler);
		}
	};

	deleteAd = (deleteItem) => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Advertisment Deleted", "", 5000);
				this.props.getAdsList();
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};
		this.props.deleteAd(deleteItem, successHandler);
	};

	render() {
		return (
			<AdListing
				adsList={this.props.adsList}
				getAdsList={this.props.getAdsList}
				submitAd={this.submitAd}
				deleteAd={this.deleteAd}
			/>
		);
	}
}

const mapStateToProps = (state) => {
	const { AdManagement, Auth } = state;
	return {
		adsList: get(AdManagement, "ads_list", []),
		isAdmin: Auth.isAdmin
	};
};

const mapDispatchToProps = {
	getAdsList,
	addNewAd,
	updateAd,
	deleteAd,
	resetForm: reset
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AdManagement);
